module.exports = __webpack_public_path__ + "assets/img/reserve-success-b6e8dafe.png";